/* eslint-disable camelcase */
import { useEffect, useState, useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPersonalInfo, getFavoriteOrg } from '../actions';
import { ORG_INDICATOR_TYPES } from '../constants';


export const useOrgIndicator = ({
  currentOrgIndicator = ORG_INDICATOR_TYPES.PERSON,
  onOrgIndicatorChange
}) => {
  const dispatch = useDispatch();
  const [org_indicator, setOrgIndicator] = useState(currentOrgIndicator);

  useEffect(() => {
    setOrgIndicator(currentOrgIndicator);
  }, [currentOrgIndicator]);

  useEffect(() => {
    dispatch(getPersonalInfo());
    dispatch(getFavoriteOrg());
  }, [dispatch]);

  const persons = useSelector((state) => state.personalInfo.data);
  const { favorites } = useSelector((state) => state.organisation);

  const handleOrgIndicatorChange = useCallback((value) => {
    setOrgIndicator(value);
    if (onOrgIndicatorChange) {
      onOrgIndicatorChange(value);
    }
  }, [onOrgIndicatorChange]);

  const organisationOrPersonOptions = useMemo(() => {
    if (!org_indicator) return [];
    
    return org_indicator === ORG_INDICATOR_TYPES.ORG
     ? (favorites || []).map(({ id, organisation, organisation_data }) => ({
        id: organisation, // Use organisation_id
        long_description_eng: organisation_data?.name || '',
        long_description_deu: organisation_data?.name || '',
        country_id: organisation_data?.country,
        state_id: organisation_data?.state,
        city_location: organisation_data?.city_location,
      }))
      // ? (favorites || []).map(({ id, organisation_data }) => ({
      //     id,
      //     long_description_eng: organisation_data?.name || '',
      //     long_description_deu: organisation_data?.name || '',
      //     country_id: organisation_data?.country,
      //     state_id: organisation_data?.state,
      //     city_location: organisation_data?.city_location,
      //   }))
      : (persons || []).map(({ id, first_name, other_names, last_name }) => ({
          id,
          long_description_eng: `${first_name || ''} ${last_name || other_names || ''}`.trim(),
          long_description_deu: `${first_name || ''} ${last_name || other_names || ''}`.trim(),
        }));
  }, [org_indicator, favorites, persons]);

  return {
    org_indicator,
    handleOrgIndicatorChange,
    organisationOrPersonOptions,
  };
};


